import React from "react";
import { View, TouchableOpacity, Text, ViewPropTypes } from "react-native";
import PropTypes from "prop-types";
import CustomText from "./CustomText";

export const RadioButtonGroup = (props) => {
  const {
    selected,
    size,
    onSelected,
    children,
    containerStyle,
    containerOptionStyle,
    radioStyle,
    radioBackground,
    labelStyle,
  } = props;

  return (
    <View style={{ ...containerStyle }}>
      {!children?.length ? (
        <TouchableOpacity
          onPress={() => onSelected(children?.props?.value)}
          activeOpacity={1}
        >
          {React.cloneElement(children, {
            selected,
            radioBackground,
            radioStyle,
            containerOptionStyle,
            labelStyle,
            size,
          })}
        </TouchableOpacity>
      ) : (
        children?.map((child, index) => {
          return (
            <TouchableOpacity
              activeOpacity={1}
              onPress={() => onSelected(child?.props?.value)}
              key={index}
            >
              {React.cloneElement(child, {
                selected,
                radioBackground,
                radioStyle,
                containerOptionStyle,
                labelStyle,
                size,
              })}
            </TouchableOpacity>
          );
        })
      )}
    </View>
  );
};

export function RadioButtonItem(props) {
  const {
    selected,
    value,
    size = 25,
    containerOptionStyle,
    radioStyle,
    radioBackground = "blue",
    labelStyle,
    label,
    style,
  } = props;

  return (
    <View
      style={{
        flexDirection: "row",
        alignItems: "center",
        ...containerOptionStyle,
      }}
    >
      <View
        style={{
          borderWidth: 2,
          borderColor: "#828282",
          padding: 2,
          width: size - 1,
          height: size,
          borderRadius: 50,
          alignItems: "center",
          justifyContent: "center",
          ...radioStyle,
          ...style,
        }}
      >
        <View
          style={{
            backgroundColor:
              selected == value ? radioBackground : "rgba(0,0,0,0)",
            width: "80%",
            height: "80%",
            borderRadius: 50,
          }}
        ></View>
      </View>

      {typeof label == "string" ? (
        <CustomText style={{ marginLeft: 3, ...labelStyle }}>
          {label}
        </CustomText>
      ) : (
        React.cloneElement(label, {
          style: { marginLeft: 3, ...label.props.style },
        })
      )}
    </View>
  );
}

RadioButtonGroup.propTypes = {
  selected: PropTypes.any,
  onSelected: PropTypes.func,
  containerStyle: PropTypes.any,
  containerOptionStyle: PropTypes.any,
  radioStyle: PropTypes.any,
  labelStyle: PropTypes.any,
  radioBackground: PropTypes.string,
  size: PropTypes.number,
};

RadioButtonItem.propTypes = {
  value: PropTypes.any,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  style: PropTypes.any,
};

export default RadioButtonGroup;
